import { MobileMenu } from './mobile-menu';

function init() {
    const menuBoxSelector = '#panel-sidebar';
    const $customerPanelMobileMenu = $(menuBoxSelector);
  
    if ($customerPanelMobileMenu.length) {  
        const swipeHandler = function() {
            mobileMenu.$menuCloseBtn.trigger('click');
        };         
        const mobileMenu = new MobileMenu({
            maxScreenSize: 1024,
            menuBoxSelector: menuBoxSelector,
            menuTriggerSelector: '#sidebar-trigger',
            menuCloseBtnSelector: '#sidebar-close-btn',
            pageCoverParentSelector: 'body',
            activeClass: 'is-active',
            onClose: function() {
                $(document).off('swiperight', swipeHandler);             
            },
            onOpen: function() {
                $(document).one('swiperight', swipeHandler);
            }
        });
    }
};


export const SidebarTrigger = {
    init
}